<template>
  <Comments :params="params" :key="version" />
</template>

<script>
import {defineComponent, onMounted, ref} from "vue"
import Comments from "@/modules/comments/pages/comments/components/comments/Comments"

export default defineComponent({
  name: "SiteComments",
  components: {
    Comments
  },
  setup() {
    let version = ref(0)

    let params = {
      title: "Комментарии на Сайте",
      h1: "Комментарии на Сайте",
      page: "site_comments",
      channels: [1],
    }

    onMounted(() => {
      version.value++
    })

    return {
      params,
      version,
    }
  }
})
</script>

<style scoped>

</style>
